export interface IParkingInformation {
  readonly isParkingFree: boolean;
  readonly cost: number;
  readonly costType: ParkingCostEnum;
  readonly parkingType: ParkingTypeEnum;
}

export enum ParkingCostEnum {
  Hourly = 'hr',
  Daily = 'day',
}

export enum ParkingTypeEnum {
  OnSiteParking = 'On-site parking',
  StreetParking = 'Street parking',
  ParkingGarage = 'Parking garage',
  OffSiteParkingLot = 'Off-site parking lot',
  Other = 'Other',
}
